module.exports = __webpack_public_path__ + "img/eee92a4.png";